import axios from "axios";
import React from 'react';
import * as constants from "./constants";
import { logoutUser, resetPayment, refreshAuthToken } from "./actions/authActionCreators";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as logger from './../logger';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core';
import RollbarErrorTracking from '../desktop/logger/RollbarErrorTracking';
import { sendError } from "../utils/utils";
const SLACK_HOOK_URL='https://hooks.slack.com/services/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';
const useStyles = makeStyles((theme) => ({
  divV1: {
    display: 'flex', height: '100%'
  }
}));


function ErrorToastMessage({ message, closeToast }) {
  const classes = useStyles();

  return <div className={classes.divV1}>
    <div style={{ width: '3%', backgroundColor: 'red' }}>&nbsp;</div>
    <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 10, paddingTop: 10, marginLeft: 15 }}>
      <div>
        <CloseIcon style={{ color: 'red' }} />
      </div>
      <div style={{ marginLeft: 10 }}>
        <div style={{ fontSize: 20, fontWeight: 300, letterSpacing: "1px" }}>
          Failed
        </div>
        <div style={{ fontSize: 16, fontWeight: 'normal', color: '#505050' }}>
          {message}
        </div>
      </div>
    </div>
  </div>
}
let axiosRequestInterceptor = null;
let axiosResponseInterceptor = null;
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  })
  
  failedQueue = [];
}
export const apiMiddleware = ({ dispatch, getState }) => (next) => (action) => {

  if (action.type !== constants.API) return next(action);

  if (action.payload && !action.payload.doNotDisplaySpinner) {
    dispatch({ type: constants.TOGGLE_LOADER });
  }
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const USER_ID = getState().user.userId;
  const userInfo = getState().user.userInfo;
  let deviceID = localStorage.getItem('deviceid');
  const {
    url,
    method,
    success,
    data,
    postProcessSuccess,
    postProcessError,
    doNotDisplaySpinner,
  } = action.payload;
  //remove interceptors
  /*if (!!axiosRequestInterceptor || axiosRequestInterceptor === 0) {
    axios.interceptors.request.eject(axiosRequestInterceptor);
  }
  if (!!axiosResponseInterceptor || axiosResponseInterceptor === 0) {
    axios.interceptors.response.eject(axiosResponseInterceptor);
  }*/
  // Add a request interceptor
  axiosRequestInterceptor = axios.interceptors.request.use(
  config => {
      const user = JSON.parse(localStorage.getItem("USER_INFO"));
      const AUTH_TOKEN_INFO = user&& user.tokenInfo?user.tokenInfo:'';
      if(config && config.url && config.url===SLACK_HOOK_URL){

      }else{
        config.headers['user-from'] = 'D-WEB';
        if (deviceID) {
          config.headers["deviceid"] = deviceID;
        }
        let token = AUTH_TOKEN_INFO && AUTH_TOKEN_INFO.accessToken?AUTH_TOKEN_INFO.accessToken: localStorage.getItem('USER_FROM_WEB')? localStorage.getItem('USER_FROM_WEB'):null;
        if (AUTH_TOKEN_INFO && config && config.url && config.url ===BASE_URL+'/generate_access_token') {
            let refreshToken = AUTH_TOKEN_INFO && AUTH_TOKEN_INFO.refreshToken?AUTH_TOKEN_INFO.refreshToken: localStorage.getItem('USER_FROM_WEB_REFRESH')? localStorage.getItem('USER_FROM_WEB_REFRESH'):null;
            config.headers['Authorization'] = 'Bearer ' + refreshToken;
        }else if (config && config.url && (config.url==='https://tpbook.s3.ap-south-1.amazonaws.com/resources/cities.txt' || config.url===SLACK_HOOK_URL)){
            delete config.headers.common["Authorization"] ;
        }else if(token){
          config.headers['Authorization'] = 'Bearer ' + token;
        }
      }
      return config;
  },
  error => {
      Promise.reject(error)
  });
  const requestDetails = {
    url: url.startsWith("http") ? url : BASE_URL + url,
    method: method,
    requestData: data ? data : {},
    userId: USER_ID ? USER_ID : null,
    userName: userInfo && userInfo.companyName ? userInfo.companyName : '',
    contactNumber: userInfo && userInfo.contactNumber ? userInfo.contactNumber : ''
  }
  axiosResponseInterceptor = axios.interceptors.response.use((response)=>response, function (err) {
  const originalRequest = err.config;
  if (err && err.response &&  err.response.status === 440 && !originalRequest._retry) {
          /*dispatch(refreshAuthToken((response)=>{
            if (response && response.status && response.status.code === 200 && response.accessToken) {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.accessToken;
              return axios(originalRequest);
            }else if (response && response.data && response.data.status && response.data.status.code === 401){
              return Promise.reject(response);
            }
          },()=>{
            return Promise.reject();
          }));*/
          if (isRefreshing) {
            return new Promise(function(resolve, reject) {
              failedQueue.push({resolve, reject})
            }).then(token => {
              originalRequest.headers['Authorization'] = 'Bearer ' + token;
              return axios(originalRequest);
            }).catch(err => {
              return Promise.reject(err);
            })
          }
          originalRequest._retry = true;
          isRefreshing = true;
          return new Promise(function (resolve, reject) {
            axios.get(BASE_URL+'/generate_access_token')
            .then(response => {
                // If request is good...
                if (response && response.data && response.data.status && response.data.status.code === 200 && response.data.accessToken) {
                  const user = JSON.parse(localStorage.getItem("USER_INFO"));
                  localStorage.setItem("USER_INFO", JSON.stringify({
                    ...user,
                    tokenInfo:{
                      ...user.tokenInfo,
                      accessToken:response.data.accessToken
                    }
                  }));
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.accessToken;
                  originalRequest.headers['Authorization'] = 'Bearer ' + response.data.accessToken;
                  processQueue(null, response.data.accessToken);
                  resolve(axios(originalRequest));
                }else if (response && response.data && response.data.status && (response.data.status.code === 401 || response.data.status.code === 403)){
                  dispatch(resetPayment());
                  dispatch(logoutUser());
                }
              }).catch((err) => {
                processQueue(err, null);
                reject(err);
              }).finally(() => { isRefreshing = false });
         });
    }
    return Promise.reject(err);
 }); 
  axios({
    method,
    url: url.startsWith("http") ? url : BASE_URL + url,
    data: data ? data : null,
  })
    .then((response) => {
      logger.log("middleware", success);
      // dispatch({ type: constants.TOGGLE_LOADER });
      if (success) {
        let data = response.data;
        logger.log("middleware", data);
        if (data.status && data.status.code && data.status.code === 401) {
          dispatch(resetPayment());
          dispatch(logoutUser());
        }
        else if (data.status && data.status.code && data.status.code !== 200) {
          logger.log("middleware", response.data);
          sendError(data.status.message)
          requestDetails.requestResponse = data;
          //RollbarErrorTracking.logError(data && data.status && data.status.message?data.status.message:'error on api call',requestDetails);
          postProcessError(response.data);
          // dispatch({ type: constants.TOGGLE_LOADER });
          /*toast.error(<ErrorToastMessage message={data.status.message} />,
            {
              className: 'toastContainer',
              closeOnClick: true,
              closeButton: true,
              // transition: Zoom,
              pauseOnHover: false,
            }
          );*/
        } else {
          dispatch(success(response.data));
        }
      }
      if (postProcessSuccess) postProcessSuccess(response.data);
      // dispatch({ type: constants.TOGGLE_LOADER });
      if (!doNotDisplaySpinner) {
        dispatch({ type: constants.TOGGLE_LOADER });
      }
    })
    .catch((err) => {
      requestDetails.requestResponse = err;
      if (err && err.response && err.response.status !== 440) {
        if(err && err.response && err.response.data && err.response.data.message){
          RollbarErrorTracking.logError(err && err.response && err.response.data && err.response.data.message ? err.response.data.message : 'error on api call', requestDetails);
        }else{
          axios.post(SLACK_HOOK_URL, JSON.stringify({
            'text':`Error On API Call${JSON.stringify(requestDetails)}`
          }))
          .then(response => {});
        }
      }

      if (!doNotDisplaySpinner) {
        dispatch({ type: constants.TOGGLE_LOADER });
      }

      if (!err.response) console.warn(err);
      else {
        if (err.response && (err.response.status === 403 || err.response.status === 401)) {
          dispatch(resetPayment());
          dispatch(logoutUser());
        };
        if (
          err.response.data &&
          err.response.data.error &&
          err.response.data.error.message
        ) {
          if (postProcessError)
            postProcessError(err.response.data.error.message);
        } else {
          if (postProcessError)
            postProcessError("Unable to process Contact Support");
        }
      }
    });
};
